import React, { useState } from "react";
import { Form, Button, Container, Card, Alert, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import logo from "../assets/mboxLogo.jpeg";
import { recoverPassword } from "../api/api";

const RecuperarContrasena = () => {
  const [email, setEmail] = useState("");
  const [successMessage, setSuccessMessage] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false); // Nuevo estado para manejar el loading
  const navigate = useNavigate();

  const handleRecovery = async () => {
    setIsLoading(true); // Iniciar el loader
    try {
      const response = await recoverPassword(email);
      if (response.ok) {
        setSuccessMessage(
          "Se ha enviado un correo para restablecer tu contraseña."
        );
        setErrorMessage(null);
      } else {
        setErrorMessage("No se pudo enviar el correo. Verifica tu dirección.");
        setSuccessMessage(null);
      }
    } catch (error) {
      setErrorMessage("Ocurrió un error inesperado.");
      setSuccessMessage(null);
    } finally {
      setIsLoading(false); // Detener el loader
    }
  };

  return (
    <Container
      fluid
      className='d-flex justify-content-center align-items-center vh-100'
      style={{
        background: "linear-gradient(135deg, #f9f9f9, #e6ecf4)",
      }}
    >
      <Card
        style={{
          width: "400px",
          padding: "30px",
          borderRadius: "20px",
          boxShadow: "0px 8px 30px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Card.Body>
          <div className='text-center mb-4'>
            <img
              src={logo}
              alt='MBox Logo'
              style={{ width: "120px", marginBottom: "10px" }}
            />
            <h3 style={{ color: "#1F2F50" }}>Recuperar Contraseña</h3>
          </div>
          {successMessage && <Alert variant='success'>{successMessage}</Alert>}
          {errorMessage && <Alert variant='danger'>{errorMessage}</Alert>}

          <Form>
            <Form.Group className='mb-3' controlId='formBasicEmail'>
              <Form.Label>Correo Electrónico</Form.Label>
              <Form.Control
                type='email'
                placeholder='Ingrese su correo registrado'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Form.Group>

            <Button
              style={{
                backgroundColor: "#F5A623",
                border: "none",
                width: "100%",
                color: "#fff",
                fontWeight: "bold",
              }}
              onClick={handleRecovery}
              disabled={isLoading} // Deshabilitar el botón mientras carga
            >
              {isLoading ? (
                <Spinner
                  animation='border'
                  size='sm'
                  style={{ marginRight: "10px" }}
                />
              ) : (
                "Enviar enlace de recuperación"
              )}
            </Button>

            <div className='text-center mt-3'>
              <Button
                variant='link'
                style={{ color: "#1F2F50", textDecoration: "none" }}
                onClick={() => navigate("/")}
              >
                Volver al inicio de sesión
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default RecuperarContrasena;
